import { useCallback, useMemo } from 'react';

import { trackAction } from '@ctct/distui-helpers';

const useTrackActions = ({ feature, featureRequirements, activity, isTwoStepDialog, launchPoint }) => {
  const trackingText = useMemo(() => {
    // eslint-disable-next-line no-underscore-dangle
    const _feature = feature || featureRequirements?.map((item) => item.feature).toString();
    // eslint-disable-next-line no-underscore-dangle
    const _activity = activity || featureRequirements?.map((item) => item.activity).toString();

    const stepAmount = isTwoStepDialog ? 'two' : 'one';
    const launchPointInfo = launchPoint ? `, launched from ${launchPoint}` : '';

    return `Feature Upgrade Dialog, ${stepAmount} step dialog, ${_feature}.${_activity}${launchPointInfo}`;
  }, [isTwoStepDialog, feature, activity, launchPoint]);

  const trackActionOnOpen = useCallback(() => {
    trackAction({
      action: `Open ${trackingText}`,
    });
  }, [trackingText]);

  const trackActionOnClose = useCallback(() => {
    trackAction({
      action: `Dismiss ${trackingText}`,
    });
  }, [trackingText]);

  const trackLeaveActionOnStay = useCallback(() => {
    trackAction({
      action: `Feature Upgrade Dialog, staying with unsaved changes`,
    });
  }, []);

  const trackLeaveActionOnProceed = useCallback(() => {
    trackAction({
      action: `Feature Upgrade Dialog, proceeding with unsaved changes`,
    });
  }, []);

  return {
    trackActionOnOpen,
    trackActionOnClose,
    trackLeaveActionOnProceed,
    trackLeaveActionOnStay,
  };
};

export default useTrackActions;
